import React from "react";
export default ({ user, disabled }) => (
  <div className="form-row">
    <div className="col-100 col-md-25 d-flex align-items-center">
      <label className="m-0">Email</label>
    </div>
    <div className="col-100 col-md-75">
      <input disabled={disabled} type="email" name="email" className="form-control" placeholder="email" defaultValue={user.email} />
    </div>
  </div>
);
